import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import appSlice from "./libs/appSlice";
import taskSlice from "./libs/taskSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    task: taskSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
